export default function OLMPromise() {
    return (
        <div className="container mx-auto my-16">
            <div className="md:space-y-0 md:space-x-4 flex items-center space-y-5 px-10 pt-5 md:pb-[35px]">
                <div className="md:w-2/4 md:text-left text-center">
                    <div className="md:w-2/4 md:hidden h-full">
                        <img
                            src="/assets/about-us/promise-banner-mobile.webp"
                            alt="A close-up of a firm handshake between two people, framed by concentric orange circles on a grey background. Two icons, a globe and an arrow hitting a target, are overlaid."
                            title="Business handshake and successful partnership."
                        />
                    </div>
                    <br />
                    <h3 className="md:text-[35px] md:leading-[41.09px] text-3xl font-bold text-start">
                        <span>The Open Letter</span>
                        <br />
                        <span>Marketing </span>
                        <span className="olm-gradient-text">Promise</span>
                    </h3>

                    <br className="md:hidden" />
                    <p className="md:text-[20px] text-[18px] text-[#000000] md:mr-[2.75rem] text-start md:pt-3 font-medium">
                        We understand the grind, the passion, and the dedication
                        it takes to succeed in real estate investing.
                        That&apos;s why we&apos;re more than just a direct mail
                        company - we&apos;re your strategic partner in success.
                        With Open Letter Marketing, you&apos;re not just getting
                        a service; you&apos;re gaining an ally with a proven
                        track record and a deep understanding of what it takes
                        to make it in this competitive market.
                    </p>
                </div>
                <div className="md:w-2/4 md:block h-full hidden">
                    <img
                        src="/assets/about-us/promise-banner.webp"
                        alt="A close-up of a firm handshake between two people, framed by concentric orange circles on a grey background. Two icons, a globe and an arrow hitting a target, are overlaid."
                        title="Business handshake and successful partnership."
                    />
                </div>
            </div>
        </div>
    )
}
